import { GalleryItem } from 'lightgallery/lg-utils';
import { AssetAttachmentCard, AttachmentCard } from 'types/Attachments';
import { getAttachmentsCardsSources, isAssetCard } from 'utils/attachments';
import { getCardMedia } from 'app/modules/posts/utils/cardMedia';

type Card = AttachmentCard | AssetAttachmentCard;

/**
 * A card can be opened in the lightbox only when it resolves to ready,
 * non-document media. Preparing and failed media have no playable URL, so
 * they are left out of the gallery, and the index math below uses the same
 * predicate to stay aligned with it.
 */
export function canPreviewInLightbox(card: Card): boolean {
  const media = getCardMedia(card);
  return !!media && media.kind !== 'document' && media.status === 'ready';
}

export function getLightboxIndex(cards: Card[], index: number): number {
  return cards.slice(0, index).filter(canPreviewInLightbox).length;
}

export function getLightboxItems(cards: Card[]): GalleryItem[] {
  return cards.filter(canPreviewInLightbox).map(toGalleryItem);
}

function toGalleryItem(card: Card): GalleryItem {
  if (!isAssetCard(card)) {
    return getAttachmentsCardsSources([card])[0];
  }
  const media = getCardMedia(card);
  const url = media?.url ?? '';
  if (media?.kind === 'video') {
    const poster = media.customThumbnailUrl ?? undefined;
    return {
      poster,
      thumb: poster,
      video: {
        source: [{ src: url, type: media.mimeType ?? 'video/mp4' }],
        // @ts-expect-error lightGallery types `attributes` as a full HTMLVideoElement
        attributes: { controls: true },
        tracks: [],
      },
    };
  }
  return { src: url, thumb: card.asset.thumbnail_url ?? url };
}
